import { useMemo } from "react";
import { useLocalStorage } from "@/hooks/use-local-storage";
import { useMerchant } from "@/providers/MerchantProvider";

const MAX_SEEN_ROWS = 500;

// Applied to a seen row's first cell. Titles set their own primary colour, so those are
// recoloured too; secondary text such as a @handle keeps its tertiary colour.
export const SEEN_ROW_CLASS =
  "text-brand-secondary text-ellipsis [&_.text-primary]:text-brand-secondary [&_.text-primary]:text-ellipsis [&_.text-gray-700]:text-brand-secondary [&_.text-gray-700]:text-ellipsis";

export const useSeenRows = (tableKey: string) => {
  const merchantId = useMerchant();
  const [seenRows, setSeenRows] = useLocalStorage<string[]>(`seen-rows:${merchantId}:${tableKey}`, []);
  const seen = useMemo(() => new Set(seenRows), [seenRows]);

  return {
    isSeen: (rowId: string) => seen.has(rowId),
    markSeen: (rowId: string) =>
      setSeenRows((rows) => [...rows.filter((id) => id !== rowId), rowId].slice(-MAX_SEEN_ROWS)),
    // react-aria caches rendered rows per item, so this goes in Table.Body `dependencies` to
    // repaint them when a row is marked.
    seenCount: seen.size,
  };
};
